// Accessor for the graph's own community color scale.
//
// The color logic is NOT duplicated here — it lives in @infranodus/infranodus-graph
// (src/utils `autoColorScale = scaleOrdinal(schemePaired)`), which exposes that
// live, stateful d3 scale on `window.infranodusGraphGetGroupColor`. We read the
// same instance so AI-chat topic/concept chips match the rendered graph exactly.
export const getGroupColor = (group, fallback = '#8c04ff') => {
    const fn =
        typeof window !== 'undefined' && window.infranodusGraphGetGroupColor
    const color = fn ? fn(group) : null
    return color == null ? fallback : color
}
